import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useRecoilValue } from "recoil"

import PaymentCreateModal from "components/Payment/modal/PaymentCreateModal"
import { AppMain } from "components/layout/MainLayout"

import PaymentCardList from "../components/Payment/PaymentCardList"
import MainMenu from "../components/molecules/MainMenu"
import { t } from "../lib/i18n"
import { safeRedirectUri } from "../lib/safeRedirect"
import useCurrentTeam from "../recoils/atoms/currentTeam"

function Payment(): JSX.Element {
  const currentTeam = useRecoilValue(useCurrentTeam)
  const [isVisibleModal, setVisibleModal] = useState(false)
  const location = useLocation()
  const [returnUrl, setReturnUrl] = useState<string | undefined>()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    // カード登録後に Stripe がこの URL へ遷移させる（setup_intent_client_secret などのクエリ付き）。
    // ログイン後の戻り先と同じ許可リストで検証し、通らなければ redirect_uri が無いのと同じに扱う
    // （モーダルも自動で開かない）。正規の呼び出し元は CLOUD / workbench の画面（#445）
    const redirectUri = searchParams.get("redirect_uri")
    const safeReturnUrl =
      redirectUri && redirectUri.startsWith("https://")
        ? safeRedirectUri(redirectUri, "")
        : ""
    if (safeReturnUrl) {
      setReturnUrl(safeReturnUrl)
      setVisibleModal(true)
    }
  }, [location])

  const showModal = () => {
    setVisibleModal(true)
  }

  const onHiddenModal = () => {
    setVisibleModal(false)
  }

  return (
    <AppMain aside={<MainMenu />} title={t("payment_method")}>
      <PaymentCardList onClickCreate={showModal} />
      <PaymentCreateModal
        isVisible={isVisibleModal}
        onCancel={onHiddenModal}
        team={currentTeam}
        returnUrl={returnUrl}
      />
    </AppMain>
  )
}

export default Payment
